'use strict';

angular.module('app.userManagement', [])
	.controller('userManagementCtrl', ['$scope', '$rootScope', '$modal', '$stateParams', '$state', 'adminService', 'userManagementService',
		function ($scope, $rootScope, $modal, $stateParams, $state, adminService, userManagementService){
		    $scope.preLoaded = false;
		    $scope.InfluencersAll = [];
		    $scope.currentPage = 1;
		    $scope.pageSize = 10;
		    $scope.fieldName = null;
		    $scope.order = true;
		    $scope.tempOrder = true;
		    $scope.currentUrl = null;
		    $scope.Header = ["",""];
		    $scope.iconName = "";
		    
		    $scope.getNewUsers = function(){
		        if($stateParams.data == null){
		            var params = {
		                searchString: $scope.searchString,
		                pageNo: $scope.currentPage,
		                sortByColumn: null,
		                sortType: null
		            }   

		            var searchUnassignUserUrl = $rootScope.apiUrl + 'admin/searchUnassignUser';         
		            $scope.currentUrl = searchUnassignUserUrl;
		            $scope.sendHttpPOST(params, searchUnassignUserUrl);

		        } else if($stateParams.data != null){
		            $scope.company = $stateParams.data.index;
		           	var params = {
		                companyId: $scope.company != null ? $scope.company.id : null,
		                pageNo: $scope.currentPage,
		                sortByColumn: null,
		                sortType: null
		           }     

		           var getUserByCompanyUrl = $rootScope.apiUrl + 'admin/getUserByCompany'; 
		           $scope.currentUrl = getUserByCompanyUrl;   
		           $scope.sendHttpPOST(params, getUserByCompanyUrl);    
		        }
		       
		       $scope.preLoaded = true;
		    };

		    $scope.sendHttpPOST = function(params, url){
		    	userManagementService.getUserManagementData(params, url, true)
		    		.then(function(responseUserManagement) {
		    			$scope.userByCompany = responseUserManagement.data;
			            $scope.number = responseUserManagement.totalRow;            
			            $scope.pagination();
		    		}, function(responseUserManagement) {
		    			var errorModalInstance = $modal.open({
		                    scope: $scope,
		                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                    windowClass: 'modal-dialog-mention-error'
		                });
		                $scope.errorModalInstance = errorModalInstance;
		                $scope.errorMessage = responseUserManagement.message;
		    		})     
		    };

		    if(!$scope.preLoaded){
		        $scope.getNewUsers();
		    };

		    $scope.getUserStatusIcon = function (user_status_id){
		        return adminService.getUserStatusIcon(user_status_id);
		    }

		    $scope.pagination = function(){
		        if($scope.number > 10){
		            if(($scope.number % $scope.pageSize) != 0){
		                var remainNo = $scope.number - ($scope.number % $scope.pageSize) 
		                $scope.pages = remainNo/$scope.pageSize + 1;
		            } else{
		                $scope.pages = $scope.number/$scope.pageSize;
		            }
		        } else{
		            $scope.pages = 1;
		        }    
		    };

		    //Sort by Column
		    $scope.sort = function(fieldname){
		        if($scope.fieldName != fieldname){
		            $scope.fieldName = fieldname;
		            $scope.tempOrder = $scope.order;
		            $scope.order = $scope.order;
		        }
		        if($scope.fieldName == fieldname){
		            $scope.tempOrder = $scope.order;
		            $scope.order = !$scope.order;
		        }
		        if($scope.tempOrder == true){
		            $scope.iconName = "glyphicon glyphicon-chevron-down";
		        } else{
		            $scope.iconName = "glyphicon glyphicon-chevron-up";
		        }
		        if($scope.fieldName === 'firstName')
		        {
		            $scope.Header[0] = $scope.iconName;
		        }
 
		        var params = {
		            pageNo: 1,
		            sortByColumn: $scope.fieldName,
		            sortType: $scope.tempOrder        
		        }

		        var userManagementSortUrl = $scope.currentUrl;
		        $scope.currentPage = 1;

		        $scope.sendHttpPOST(params, userManagementSortUrl);         
		    };


		    $scope.updatePage = function(page) {
		        var params = {
		        	companyId: $scope.company != null ? $scope.company.id : null,
		            pageNo: page,
		            sortByColumn: $scope.fieldName,
		            sortType: $scope.tempOrder
		        }

		        var userManagementUpdateUrl = $scope.currentUrl;
		        $scope.currentPage = page;
		        $scope.sendHttpPOST(params, userManagementUpdateUrl);   

		    };

		    $scope.editUserModalHandler = function (index) {
		        var editUserModalInstance = $modal.open({
		            scope: $scope,
		            templateUrl: 'app/admin/userAndBilling/userManagement/editUserProfile/editUserProfile.html?app_v=deployDate',
		            controller: 'editUserProfileCtrl'
		        });

		        editUserModalInstance.result.then(function() {
		            $scope.getNewUsers();
		          }, function() {
		            
		          });

		        $scope.editUserModalInstance = editUserModalInstance;
		        $scope.index = index;
		    };  

		    $scope.activateUser = function(index){
		        userManagementService.activeUser(index.id, true)
		        	.then(function(response) {
		        		$scope.getNewUsers();
		        	}, function(response) {
		        		var errorModalInstance = $modal.open({
		                    scope: $scope,
		                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                    windowClass: 'modal-dialog-mention-error'
		                });
		                $scope.errorModalInstance = errorModalInstance;
		                $scope.errorMessage = response.message;
		        	})
		    };

		    $scope.deactivateUser = function(index){
		        userManagementService.deactivateUser(index.id, true)
		        	.then(function(response) {
		        		$scope.getNewUsers();
		        	}, function(response) {
		        		var errorModalInstance = $modal.open({
		                    scope: $scope,
		                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                    windowClass: 'modal-dialog-mention-error'
		                });
		                $scope.errorModalInstance = errorModalInstance;
		                $scope.errorMessage = response.message;
		        	})
		    };

		    $scope.deleteUser = function(index){        
		        var params = {
		            userId: index.id,
		            companyId: index.company == null ? null : index.company.id
		        }
		        
		        userManagementService.deleteUser(params, true)
		        	.then(function(response) {
		        		$scope.getNewUsers();
		        	}, function(response) {
		        		var errorModalInstance = $modal.open({
		                    scope: $scope,
		                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                    windowClass: 'modal-dialog-mention-error'
		                });
		                $scope.errorModalInstance = errorModalInstance;
		                $scope.errorMessage = response.message;
		        	})
		    };

		    $scope.inviteUser = function(){
		        $scope.successMessage = null;
		        $scope.errorMessage = null;
		        var companyId = null;
		        $stateParams.data == null ? companyId = null : companyId = $stateParams.data.index.id;
		        if($scope.inviteUserEmail == null || $scope.inviteUserEmail == "") {
		            $scope.errorMessage = "Please input email for sending invitation";
		        } else {
		            var params = {
		                companyId: companyId,
		                userEmail: $scope.inviteUserEmail,
						hostName: window.location.hostname 
		            }

		            userManagementService.inviteNewUser(params, true)
		        	.then(function(responseInviteUser) {
		        		$scope.getNewUsers();
		                $scope.successMessage = responseInviteUser.message;
		        	}, function(responseInviteUser) {
		        		var errorModalInstance = $modal.open({
		                    scope: $scope,
		                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                    windowClass: 'modal-dialog-mention-error'
		                });
		                $scope.errorModalInstance = errorModalInstance;
		                $scope.errorMessage = responseInviteUser.message;
		        	})      
		        };
		    }

		    $scope.userAccountAction = function(index) {
		        var userAccountActionModalInstance = $modal.open({
		            scope: $scope,
		            templateUrl: 'app/admin/userAndBilling/userManagement/userAccountAction/userAccountAction.html?app_v=deployDate',
		            controller: 'userAccountActionCtrl'
		        });

		        $scope.userAccountActionModalInstance = userAccountActionModalInstance;
		        $scope.contactData = index;
		        $scope.user_id = $scope.contactData.id;
		    }

		    $scope.userLog = function(index){
		        var userDataLog = {index : index};
		        $state.transitionTo('home.systemLog', {userDataLog: userDataLog}, {
		            reload: true,
		            inherit: false,
		            notify: true
		        });
		    };

		    $scope.reinviteUser = function(data){
		        $scope.successMessage = null;
		        $scope.errorMessage = null;
		        var companyId = null;
		        $stateParams == null ? companyId = null : companyId = $stateParams.data.index.id;

		        var params = {
		            companyId: companyId,
		            userEmail: data.email,
					hostName: window.location.hostname 
		        }

		        userManagementService.inviteNewUser(params, true)
		        	.then(function(response) {
		        		$scope.successMessage = response.message;
		            	$scope.getNewUsers();
		        	}, function(response) {
		        		var errorModalInstance = $modal.open({
		                    scope: $scope,
		                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                    windowClass: 'modal-dialog-mention-error'
		                });
		                $scope.errorModalInstance = errorModalInstance;
		                $scope.errorMessage = response.message;
		        	})  
		    }      
}])